import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import CheckoutSteps from './CheckoutSteps';
import MetaData from '../MetaData';
import { Container } from 'react-bootstrap';
import SectionHeading from '../common/SectionHeading';
import { Link, useNavigate } from 'react-router-dom';

const ConfirmOrder = () => {
    const { shippingInfo, cartItems } = useSelector((state) => state.cart);
    const { user } = useSelector((state) => state.user);
    const navigate = useNavigate();

    const subtotal = cartItems.reduce((acc, item) => acc + item.quantity * item.price, 0);
    const shippingCharges = subtotal > 1000 ? 200 : 0;
    const tax = subtotal * 0.18;
    const totalPrice = subtotal + shippingCharges + tax;

    const address = `${shippingInfo.address}, ${shippingInfo.city}, ${shippingInfo.state}, ${shippingInfo.pinCode}, ${shippingInfo.country}`;

    const proceedToPayment = () => {
        const data = {
            subtotal,
            shippingCharges,
            tax,
            totalPrice,
        };

        sessionStorage.setItem('orderInfo', JSON.stringify(data));
        navigate('/process/payment');
    };

    return (
        <>
            <MetaData title='Confirm Order' />
            <div className='section-padding-top section-padding-bottom'>
                <CheckoutSteps activeStep={1} />
                <Container className='mt-5'>
                    <SectionHeading heading={'Confirm Order'} />
                    <div className='shippingContainer'>
                        <div>
                            <h4>Shipping Info</h4>
                            <div className='confirmShippingArea'>
                                <div>
                                    <p>Name:</p>
                                    <span>{user.name}</span>
                                </div>
                                <div>
                                    <p>Phone:</p>
                                    <span>{shippingInfo.phoneNo}</span>
                                </div>
                                <div>
                                    <p>Address:</p>
                                    <span>{address}</span>
                                </div>
                            </div>
                            <div className='confirmCartItems mt-5'>
                                <h4>Your Cart Items</h4>
                                <div className='confirmCartItemsContainer'>
                                    {cartItems &&
                                        cartItems.map((item, i) => (
                                            <div key={i} className='confirmCartItem'>
                                                <img src={item.image} alt={item.name} />
                                                <Link to={`/product/${item.product}`}>
                                                    {item.name}
                                                </Link>
                                                <span className='text-end'>
                                                    {item.quantity} X Rs.{item.price} ={' '}
                                                    <b>Rs.{item.price * item.quantity}</b>
                                                </span>
                                            </div>
                                        ))}
                                </div>
                            </div>
                        </div>
                        <div className='order-summary-container'>
                            <h4>Order Summary</h4>
                            <div className='order-summary'>
                                <div>
                                    <p>Subtotal:</p>
                                    <span>Rs.{subtotal}</span>
                                </div>
                                <div>
                                    <p>GST:</p>
                                    <span>Rs.{tax}</span>
                                </div>
                                <div>
                                    <p>Shipping Charges:</p>
                                    <span>Rs.{shippingCharges}</span>
                                </div>
                            </div>
                            <div className='orderSummaryTotal'>
                                <div>
                                    <p>Total:</p>
                                    <span>Rs.{totalPrice}</span>
                                </div>
                            </div>
                            <button
                                className='primary-btn d-block w-100'
                                onClick={proceedToPayment}
                            >
                                Proceed to Payment
                            </button>
                        </div>
                    </div>
                </Container>
            </div>
        </>
    );
};

export default ConfirmOrder;
